import {SedestralInterface} from "../../SedestralInterface";
import {Component} from "../Component";

/**
 * draggable
 */
export function onDrag(component: Component, func: (left: number, top: number) => void, onFinish?: () => void, selector?: Component) {
    let initX, initY, mousePressX, mousePressY;
    let down = false;
    let tDown = false;
    let moveListener = undefined;
    let upListener = undefined;
    let tMoveListener = undefined;
    let tUpListener = undefined;
    let componentListener = (selector ? selector : component);

    let touchDown = (e) => {
        SedestralInterface.body.setStyle(`user-select:none;`);
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = e.touches[0].pageX;
            mousePressY = e.touches[0].pageY;
            tDown = true;
            tMoveListener = componentListener.putListener(window, 'touchmove', move);
            tUpListener = componentListener.putListener(window, 'touchend', touchUp);
        }
    };

    let touchUp = (e) => {
        SedestralInterface.body.setStyle(`user-select:unset;`);
        if (tDown) {
            tDown = false;
            componentListener.deleteListener(tMoveListener);
            componentListener.deleteListener(tUpListener);
            if (onFinish) {
                onFinish();
            }
        }
    };

    let mouseDown = (event) => {
        SedestralInterface.body.setStyle(`user-select:none;`);
        if (component.element instanceof HTMLElement) {
            initX = component.element.offsetLeft;
            initY = component.element.offsetTop;
            mousePressX = event.pageX;
            mousePressY = event.pageY;

            down = true;
            moveListener = componentListener.putListener(window, 'mousemove', move);
            upListener = componentListener.putListener(window, 'mouseup', mouseUp);
        }
    };

    let mouseUp = () => {
        SedestralInterface.body.setStyle(`user-select:unset;`);
        if (down) {
            down = false;
            componentListener.deleteListener(moveListener);
            componentListener.deleteListener(upListener);
            if (onFinish) {
                onFinish();
            }
        }
    };

    componentListener.addListener('touchstart', touchDown);
    componentListener.addListener('mousedown', mouseDown);

    let move = (event) => {
        if (tDown) {
            let left = initX + event.touches[0].pageX - mousePressX;
            let top = initY + event.touches[0].pageY - mousePressY;

            func(left, top);
        }

        if (down) {
            let left = initX + event.pageX - mousePressX;
            let top = initY + event.pageY - mousePressY;

            func(left, top);
        }
    }
}